import React, { useEffect, useState } from 'react';
import RichTextParser from './RichTextParser';

function ReadMoreReadLess({ children }) {
  const ref = React.useRef();

  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflown, setIsOverflown] = useState(false);

  const checkOverflow = () => {
    const element = ref.current;
    if (!element) return;
    const status =
      element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    setIsOverflown(status);
  };

  useEffect(() => {
    checkOverflow();
  }, [children, ref]);

  return (
    <>
      <div ref={ref} className={`${!isExpanded && 'line-clamp-4'}`}>
        {children && <RichTextParser>{children}</RichTextParser>}
      </div>
      {isOverflown && (
        <span
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 block cursor-pointer font-semibold underline"
        >
          {!isExpanded ? 'Show more' : 'Show less'}
        </span>
      )}
    </>
  );
}

export default ReadMoreReadLess;
